module.exports = __webpack_public_path__ + "static/media/Matcha con coco y piña.9759f18f.webp";